import dayjs from 'dayjs';
import {
  DATE_TIME_FORMAT,
  TIME_PICKER_STEP,
  TOTAL_DAYS_PER_MONTH_VIEW,
} from '../constants/date.contant';

require('dayjs/locale/ru');

export const getDaysInMonthDisplay = (_date: number) => {
  const date = dayjs(_date);
  const startMonth = date
    .clone()
    .startOf('month')
    .set('hour', date.hour())
    .set('minute', date.minute())
    .set('second', date.second());
  const endMonth = date
    .clone()
    .endOf('month')
    .add(1, 'days')
    .set('hour', date.hour())
    .set('minute', date.minute())
    .set('second', date.second());
  const firstDayMonth = (startMonth.day() ? startMonth.day() : 7) - 1;
  const result: Array<{
    currentMonth: boolean;
    date: Date;
  }> = [];

  if (firstDayMonth > 0) {
    const prevMonth = startMonth.clone().subtract(firstDayMonth, 'days');
    const range = getDateRange(prevMonth, startMonth);
    const rangeModify = range.map((dateFromRange: dayjs.Dayjs) => {
      return {
        currentMonth: false,
        date: dateFromRange.toDate(),
      };
    });
    result.push(...rangeModify);
  }

  const range = getDateRange(startMonth, endMonth);
  const rangeModify = range.map((dateFromRange: dayjs.Dayjs) => {
    return {
      currentMonth: true,
      date: dateFromRange.toDate(),
    };
  });
  result.push(...rangeModify);

  if (result.length < TOTAL_DAYS_PER_MONTH_VIEW) {
    const nextMonth = endMonth
      .clone()
      .add(TOTAL_DAYS_PER_MONTH_VIEW - result.length, 'days');
    const rangeNextMonth = getDateRange(endMonth, nextMonth);
    const rangeModifyNextMonth = rangeNextMonth.map(
      (dateFromRange: dayjs.Dayjs) => {
        return {
          currentMonth: false,
          date: dateFromRange.toDate(),
        };
      },
    );
    result.push(...rangeModifyNextMonth);
  }

  return result;
};

export const getDateRange = (
  fromDate: dayjs.Dayjs,
  toDate: dayjs.Dayjs,
  type: 'days' | 'month' = 'days',
) => {
  const diff = toDate.diff(fromDate, type);
  const range = [];
  for (let i = 0; i < diff; i++) {
    range.push(fromDate.clone().add(i, type));
  }
  return range;
};

export const getTimeRange = (_date: number) => {
  const date = dayjs(_date);
  const interval = TIME_PICKER_STEP;
  const fromTime = date
    .clone()
    .set('hour', 9)
    .set('minute', 0)
    .set('second', 0);
  const toTime = date
    .clone()
    .set('hour', 17)
    .set('minute', 45)
    .set('second', 0);
  const range = [];
  const fromTimeStart = fromTime.set(
    'minutes',
    Math.ceil(fromTime.minute() / interval) * interval,
  );
  let current = fromTimeStart.clone();

  while (current <= toTime) {
    range.push(current.clone().unix() * 1000);
    current = current.add(interval, 'minutes');
  }

  return range;
};

export const isSameDate = (
  oneDate: Date,
  twoDate: Date,
) => {
  const firstDate = dayjs(oneDate);
  const secondDate = dayjs(twoDate);
  return firstDate.isSame(secondDate, 'day');
};

export const isToday = (date: Date) =>
  dayjs(date).isSame(dayjs(new Date()), 'day');

export const isCurrentMonth = (date: Date) =>
  dayjs(date).isSame(dayjs(new Date()), 'month');

export const getDateTime = (
  date: any,
  displayFormat: string = DATE_TIME_FORMAT,
) => dayjs(date).locale('ru').format(displayFormat);
